import * as API from './../../base/api_service';
import * as serviceCallConfig from './../../config/api_urls';

export var GET_ALL_PATIENTS_DATA = 'GET_ALL_PATIENTS_DATA';
export var ADD_PATIENTS = 'ADD_PATIENTS';
export var GET_ALL_STAFF_DATA = 'GET_ALL_STAFF_DATA';
export var GET_PATIENT_INFO = 'GET_PATIENT_INFO';



export var add_patients_data = (data) => ({
    type: ADD_PATIENTS,
    data: data
});


export var addPaients = (data) => {

    return (dispatch, getState) => {

        API.makeServiceCall(
            serviceCallConfig.API_POST,//reqType
            dispatch,//dispatch
            serviceCallConfig.get(serviceCallConfig.ADD_PATIENTS),//endPoint
            data,//payLoad
            serviceCallConfig.ADD_PATIENTS,//requestFrom
            false,//isURLEncoded
            getState().User.loginData.data.accessToken, //authKey
            '',//api_key
            '',//getParams
            false,//multipart
            getState().User.loginData.data.uniqueKey, //uniqueKey
        );

    };
};





export var all_patients_data = (data) => ({
    type: GET_ALL_PATIENTS_DATA,
    data: data
});
export var getAllPaientsData = (data) => {

    return (dispatch, getState) => {

        API.makeServiceCall(
            serviceCallConfig.API_GET,//reqType
            dispatch,//dispatch
            serviceCallConfig.get(serviceCallConfig.GET_ALL_PATIENTS_DATA),//endPoint
            '',//payLoad
            serviceCallConfig.GET_ALL_PATIENTS_DATA,//requestFrom
            false,//isURLEncoded
            getState().User.loginData.data.accessToken,//authKey   getState().User.loginData.accessToken
            "",//api_key
            data,//getParams
            false,//multipart
            getState().User.loginData.data.uniqueKey, //uniqueKey
        );

    };
};





export var all_staff_data = (data) => ({
    type: GET_ALL_STAFF_DATA,
    data: data
});
export var getAllStaffData = (data) => {

    return (dispatch, getState) => {

        API.makeServiceCall(
            serviceCallConfig.API_GET,//reqType
            dispatch,//dispatch
            serviceCallConfig.get(serviceCallConfig.GET_ALL_STAFF_DATA),//endPoint
            '',//payLoad
            serviceCallConfig.GET_ALL_STAFF_DATA,//requestFrom
            false,//isURLEncoded
            getState().User.loginData.data.accessToken,//authKey   getState().User.loginData.accessToken
            "",//api_key
            data,//getParams
            false,//multipart
            getState().User.loginData.data.uniqueKey, //uniqueKey
        );

    };
};



export var get_patient_info_data = (data) => ({
    type: GET_PATIENT_INFO,
    data: data
});
export var get_patient_info = (data) => {

    return (dispatch, getState) => {

        API.makeServiceCall(
            serviceCallConfig.API_GET,//reqType
            dispatch,//dispatch
            serviceCallConfig.get(serviceCallConfig.GET_PATIENT_INFO),//endPoint
            '',//payLoad
            serviceCallConfig.GET_PATIENT_INFO,//requestFrom
            false,//isURLEncoded
            getState().User.loginData.data.accessToken,//authKey   getState().User.loginData.accessToken
            "",//api_key
            data,//getParams
            false,//multipart
            getState().User.loginData.data.uniqueKey, //uniqueKey
        );

    };
};


/* RedFlags */
export var REDFLAG = 'REDFLAG';
export var red_flag_Data = (data) => ({
    type: REDFLAG,
    data: data
});
export var get_redFlag_data = (data) => {

    return (dispatch, getState) => {

        API.makeServiceCall(
            serviceCallConfig.API_GET,//reqType
            dispatch,//dispatch
            serviceCallConfig.get(serviceCallConfig.REDFLAG),//endPoint
            '',//payLoad
            serviceCallConfig.REDFLAG,//requestFrom
            false,//isURLEncoded
            getState().User.loginData.data.accessToken,//authKey   getState().User.loginData.accessToken
            "",//api_key
            data,//getParams
            false,//multipart
            getState().User.loginData.data.uniqueKey, //uniqueKey
        );

    };
};

export var get_redFlag_list = (data, payload) => {

    return (dispatch, getState) => {

        API.makeServiceCall(
            serviceCallConfig.API_POST,//reqType
            dispatch,//dispatch
            serviceCallConfig.BASE_URL + serviceCallConfig.POST_LOG + data + '/flags/search',//endPoint
            payload,//payLoad
            serviceCallConfig.REDFLAG,//requestFrom
            false,//isURLEncoded
            getState().User.loginData.data.accessToken,//authKey   getState().User.loginData.accessToken
            "",//api_key
            data,//getParams
            false,//multipart
            getState().User.loginData.data.uniqueKey, //uniqueKey
        );

    };
};



/** WEBPACK FOOTER **
 ** ./src/actions/admin/patients_actions.js
 **/